import type { ZodiacSign } from './types'

/** Контурные пути 12 знаков зодиака, viewBox 24, stroke 1.5. Источник — UI-кит §23. */
export const ZODIAC_PATHS: Record<ZodiacSign, string> = {
  ARIES: 'M12 20V8M12 8c0-3-1.8-5-4-5S4 4.7 4 7.2M12 8c0-3 1.8-5 4-5s4 1.7 4 4.2',
  TAURUS: 'M5 3.5c0 3.9 3.1 7 7 7s7-3.1 7-7M12 10.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10z',
  GEMINI: 'M6 4h12M6 20h12M9.2 4v16M14.8 4v16',
  CANCER:
    'M3.5 9.5C3.5 7 7.3 5 12 5c2.6 0 4.9.6 6.5 1.6M20.5 14.5c0 2.5-3.8 4.5-8.5 4.5-2.6 0-4.9-.6-6.5-1.6M6.4 8.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8zM17.6 10.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z',
  LEO: 'M8 12.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM11.6 15V8.5a3.6 3.6 0 1 1 7.2 0c0 2.6-1.7 3.7-1.7 5.6 0 1.4 1 2.4 2.3 2.6',
  VIRGO:
    'M3 7.5V17M3 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7V17M7.4 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7V17M11.8 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7v6c0 3.2 1.7 5 4.3 5.5M16.2 13.5c0 3.2-1.4 5-4 5.5',
  LIBRA: 'M3 18.5h18M3.5 14.5h5.2a5 5 0 1 1 6.6 0h5.2',
  SCORPIO:
    'M3 7.5V17M3 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7V17M7.4 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7V17M11.8 7.5c0-1.7 1-2.7 2.2-2.7s2.2 1 2.2 2.7v7.6c0 1.6 1 2.7 2.5 2.7h2.3M18.6 15.4l2.4 2.4-2.4 2.4',
  SAGITTARIUS: 'M5 19 19 5M12.6 5H19v6.4M8.2 12.2l3.6 3.6',
  CAPRICORN:
    'M3.5 5.5c1.6 0 2.7 1.3 2.7 3.2V17M6.2 9.4c0-1.9 1.2-3.2 2.8-3.2S11.8 7.5 11.8 9.4v6.4M11.6 12.4c0-1.7 1.3-3 2.9-3 2.1 0 3.6 1.7 3.6 3.9 0 2.5-1.9 4.4-4.4 4.4-1 0-1.9-.3-2.6-.9',
  AQUARIUS:
    'M3 10.4 6.5 7l3.5 3.4L13.5 7 17 10.4 20.5 7M3 17.4 6.5 14l3.5 3.4L13.5 14 17 17.4 20.5 14',
  PISCES: 'M7 4c-2.6 2.6-2.6 13.4 0 16M17 4c2.6 2.6 2.6 13.4 0 16M4 12h16',
}
